import React from 'react';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { typeLabel } from '../constants/paymentLinks.constants';

export const TypeBadge = ({
  compact = false,
  type,
}: {
  compact?: boolean;
  type: string;
}) => {
  if (compact) {
    return (
      <Box
        component="span"
        sx={{
          bgcolor: 'primary.light3',
          border: '1px solid',
          borderColor: 'primary.light2',
          borderRadius: 1,
          color: 'primary.main',
          display: 'inline-flex',
          fontSize: 11,
          fontWeight: 700,
          lineHeight: 1,
          px: 0.75,
          py: 0.55,
          whiteSpace: 'nowrap',
        }}
      >
        {typeLabel[type] || type}
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={0.75}>
      {type === 'boleto' ? (
        <ReceiptLongIcon fontSize="small" color="action" />
      ) : (
        <PaymentsIcon fontSize="small" color="action" />
      )}
      <Typography variant="body2">{typeLabel[type] || type}</Typography>
    </Box>
  );
};

export const TypeIcon = ({ type }: { type: string }) => (
  <Tooltip title={typeLabel[type] || type || 'Tipo'}>
    <Box component="span" display="inline-flex" alignItems="center">
      {type === 'boleto' ? (
        <ReceiptLongIcon fontSize="small" color="action" />
      ) : (
        <PaymentsIcon fontSize="small" color="action" />
      )}
    </Box>
  </Tooltip>
);
